import React, { Component } from 'react';


class OrderStorageStatus extends Component {
    state = {
        status: [
            '', 
            React.Component.prototype.$intl.get('仍未到货'), 
            React.Component.prototype.$intl.get('订单确认收到仍未到货'), 
            React.Component.prototype.$intl.get('部分到货'), 
            React.Component.prototype.$intl.get('已经发货'), 
            React.Component.prototype.$intl.get('全部到货'), 
            React.Component.prototype.$intl.get('国内到货')],
    }

    makeStatusStyle = (status) => {
        if (status === 1 || status === 2 ) {
            return 'text-danger';
        }
        else if (status === 3 || status === 4) {
            return 'text-warning';
        }
        else if (status === 5 || status === 6) {
            return 'text-success';
        }
        else {
            return 'text-info';
        }
    }

    render() {
        const { status } = this.props;
        return (
            <span className={this.makeStatusStyle(status)}> { this.state.status[status] } </span>
        );
    }
  
}

export default OrderStorageStatus;
